<template>
    <div class="px-0 background--paper divider--container">
        <div class="divider-white--top"></div>
            <slot></slot>
        <div class="divider-white--bottom"></div>
    </div>
</template>

<script>
export default {
    name: 'PaperSection',
};
</script>
